import { render, staticRenderFns } from "./ScanBoxSewing.vue?vue&type=template&id=ac7c1d02&scoped=true&"
import script from "./ScanBoxSewing.vue?vue&type=script&lang=js&"
export * from "./ScanBoxSewing.vue?vue&type=script&lang=js&"
import style0 from "./ScanBoxSewing.vue?vue&type=style&index=0&id=ac7c1d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7c1d02",
  null
  
)

export default component.exports